<template>
    <svg class="mr-2" width="16" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 9.7a.47.47 0 100-.94.47.47 0 000 .94z" fill="#51747D" />
        <path
            d="M8 .76c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 1.9a6.1 6.1 0 016.02 5.17H12.4a3.68 3.68 0 01-2.7-1.14 2.35 2.35 0 00-3.4 0 3.68 3.68 0 01-2.7 1.14H1.98A6.1 6.1 0 018 2.67zm0 7.98a1.4 1.4 0 110-2.82 1.4 1.4 0 010 2.82zm-5.67.34a3.7 3.7 0 011.45-.34c1.71 0 3.04 1.52 2.78 3.23a2.8 2.8 0 01-.22.76 6.12 6.12 0 01-4.01-3.65zm7.33 3.65a2.82 2.82 0 013.23-3.9c.2.04.45.12.78.25a6.12 6.12 0 01-4 3.65z"
            fill="#51747D"
        />
    </svg>
</template>
